import { makeStyles } from '@material-ui/core';

export default makeStyles(
  theme => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '20px',
    },
    formTitle: {
      textAlign: 'center',
    },
    message: {
      ...theme.typography.body3,
      color: theme.palette.primary.main,
      opacity: '0.7',
      textAlign: 'center',
    },
    button: {
      display: 'block',
      marginTop: '24px',
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '267px',
      height: '40px',
    },
    signIn: {
      ...theme.typography.body3,
      textAlign: 'center',
    },
    link: {
      color: theme.palette.secondary.main,
    },
  }),
  { name: 'EmailInputForm' },
);
